import { BW_LANGUAGE_EN } from 'src/libs/qb-brand-web-components'

const brandConfig = {
  brandId: 'rewards_qiibee',
  name: 'qiibee',
  domain: 'qiibee.com',
  fbAppName: 'qiibeerewards',
  termsUrl: 'https://static.qiibee.com/rewards/terms.pdf',
  privacyPolicyUrl: 'https://www.qiibee.com/privacy-policy/',
  cookiePolicyUrl: 'https://static.qiibee.com/rewards/cookiepolicy.pdf',
  faqEmail: 'welcome@qiibee.com',
  ladUrl: 'https://dashboard.qiibee.com/',
  theme: {
    colors: {
      main: '#5F5F5F',
      accent: '#00A0E3'
    }
  },
  supportedLanguages: [BW_LANGUAGE_EN],
  features: {
    disablePrivacyCheckbox: true,
    enableImpactReport: true,
    enableRootImpactReport: true
  },
  cognito: {
    region: 'eu-central-1',
    poolId: 'eu-central-1_UkCTwfWiw',
    clientId: '7it4mad4d2ohpacrdi9g3r82lf',
    poolDomain: 'rewards-qiibee.auth.eu-central-1.amazoncognito.com',
    redirectUri: 'https://rewards.qiibee.com/login'
  },
  gaTrackingId: 'G-R350SRNHB7',
  hotjarId: '2874146',
  loyalizePid: '4156633'
}

export default brandConfig
